"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSlykTheme = createSlykTheme;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _animations = require("./animations");

var _boxShadow = require("./box-shadow");

var _colors = require("./colors");

var _styles = require("react-components/styles");

var _dimensions = require("./dimensions");

var _zIndex = require("./z-index");

var _keyframes = _interopRequireDefault(require("./keyframes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * Export `createSlykTheme`.
 */
function createSlykTheme(overrides) {
  return (0, _styles.createTheme)((0, _merge2["default"])({}, {
    animations: _animations.animations,
    boxShadow: _boxShadow.boxShadow,
    colors: _colors.colors,
    dimensions: _dimensions.dimensions,
    keyframes: _keyframes["default"],
    zIndex: _zIndex.zIndex
  }, overrides));
}